import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Truck, Package, Recycle, AlertTriangle } from 'lucide-react';
import { additionalServices } from '../mockData';

const AdditionalServices = () => {
  const iconMap = {
    Truck: Truck,
    Package: Package,
    Recycle: Recycle,
    Building2: AlertTriangle
  };

  return (
    <section id="tarifs" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Autres solutions de collecte
          </h2>
          <p className="text-xl text-gray-600">
            Pour tous vos chantiers, professionnels et particuliers
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {additionalServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="p-6 text-center hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-green-200 group"
              >
                <div className="mb-4 inline-flex">
                  <div className="bg-green-50 p-4 rounded-2xl group-hover:bg-green-100 transition-colors">
                    <IconComponent className="h-8 w-8 text-green-600" />
                  </div>
                </div>
                
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {service.name}
                </h3>
                
                <p className="text-gray-700 text-sm mb-2 font-medium">
                  {service.description}
                </p>
                
                <p className="text-gray-600 text-sm mb-4">
                  {service.details}
                </p>
                
                <Button className="w-full bg-green-600 hover:bg-green-700 text-white">
                  En savoir plus
                </Button>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            Pour une transition écologique du BTP
          </h3>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-6 leading-relaxed">
            46 millions de tonnes de déchets sont générés dans le secteur du Bâtiment tous les ans.
            On estime qu'environ 67% de ces déchets sont revalorisés. C'est dans l'optique d'améliorer
            l'empreinte carbone de la gestion des déchets du BTP que nous avons construit des services
            de collecte fiables, réactifs, traçables et adaptés à chaque déchet.
          </p>
          <p className="text-xl font-bold text-green-700 mb-8">
            Une équipe convaincue que le déchet est une ressource qui ne devrait jamais finir sous terre !
          </p>
          <Button className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-lg">
            Découvrir notre engagement
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AdditionalServices;